import React from 'react';
import Header from './header.jsx';
import Sidebar from './sidebar.jsx';
import { Button, Form, Input, message, Select } from 'antd';
import axios from 'axios';

export const AddRegistrationForm = () => {
  // Handle form submission
  const handleSubmit = async (values) => {
    const payload = {
      registrationDate: values.registrationDate,
      pageSendingPersonOrOrganization: values.pageSendingPersonOrOrganization,
      registrationLocation: values.registrationLocation,
      subject: values.subject,
      pageLength: values.pageLength, // Now supports multiple values as an array of strings
    };

    try {
      const response = await axios.post('https://ward3-chandrapur-api.palikaapp.com/api/registration/save', payload);
      message.success('दर्ता सफलतापूर्वक सुरक्षित गरियो');
    } catch (error) {
      message.error('दर्ता सुरक्षित गर्न असफल भयो।');
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="lg:w-1/5">
      <Header />
      </div>

      {/* Main Content */}
      <div className="lg:w-4/5 p-6 pt-20">
       
        <Sidebar />
        <h1 className="text-xl lg:text-2xl font-bold mt-10 lg:mt-16 text-center lg:text-center">
          दर्ता फारम
        </h1>
        <div className="flex justify-center mt-10">
          <Form
            onFinish={handleSubmit}
            className="w-full max-w-lg bg-white p-6 shadow-lg rounded-md"
            layout="vertical"
          >
            <Form.Item
              label="दर्ता मिति"
              name="registrationDate"
              rules={[{ required: true, message: 'कृपया दर्ता मिति चयन गर्नुहोस्' }]}
            >
              <Input type="date" className="w-full border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="पत्र पठाउने व्यक्ति वा संस्था"
              name="pageSendingPersonOrOrganization"
              rules={[{ required: true, message: 'कृपया पृष्ठ पठाउने व्यक्ति वा संस्था भर्नुहोस्' }]}
            >
              <Input className="w-full border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="दर्ता स्थान"
              name="registrationLocation"
              rules={[{ required: true, message: 'कृपया दर्ता स्थान भर्नुहोस्' }]}
            >
              <Input className="w-full border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="विषय"
              name="subject"
              rules={[{ required: true, message: 'कृपया विषय भर्नुहोस्' }]}
            >
              <Input className="w-full border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="पत्र संख्या"
              name="pageLength"
              rules={[{ required: true, message: 'कृपया पत्र संख्या भर्नुहोस्' }]}
            >
              <Select
                mode="tags"
                style={{ width: '100%' }}
                placeholder="पत्र संख्या भर्नुहोस्"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
              >
                सुरक्षित गर्नुहोस
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
